// extracted by mini-css-extract-plugin
module.exports =  {"shortcuts-group":"shortcuts-group-LbRfT","title":"title-eToYZ","shortcuts":"shortcuts-tQ93G","shortcut":"shortcut-swbky","label":"label-WnVj8"};